export default __webpack_public_path__ + "static/13-aa664a2b98b1d96d0ae8cf366e98a8a5.jpg";